.checkbox-group{display:flex;flex-direction:column}.checkbox-row{display:flex;gap:8px}
/*# sourceMappingURL=checkbox-output-value-accessor.component.css.map */
